import { Component } from '@angular/core';

@Component({
  selector: 'am-filters-list-skeleton',
  styleUrls: ['./filters-list-skeleton.component.scss'],
  templateUrl: './filters-list-skeleton.component.html',
})
export class FiltersListSkeletonComponent {
  constructor() {}
}
